import Tabs from './Tabs';
import Tab from './Tab';

// export types
export type { TabsProps } from './Tabs';
export type { TabProps } from './Tab';

// export components
export { Tabs, Tab };
export default Tabs;
